/*
  La Sura - matching pages and articles on the search results page (sections/search-results.liquid).

  The results page searches products only (its form sends type=product), so "allergens" or "how to
  order" found no products and no help either. This asks Shopify's search suggestions for pages and
  articles with the same words and lists them as links above the products, under a heading from the
  theme settings. Nothing shows if there are none, or without JavaScript.
*/
class LasuraSearchPages extends HTMLElement {
  async connectedCallback() {
    const terms = (this.dataset.terms || '').trim();
    const base = this.dataset.url;
    if (!terms || !base) return;

    const url = new URL(`${base}.json`, location.origin);
    url.searchParams.set('q', terms);
    url.searchParams.set('resources[type]', 'page,article');
    url.searchParams.set('resources[limit]', '4');
    url.searchParams.set('resources[limit_scope]', 'each');

    let results;
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      results = (await response.json())?.resources?.results || {};
    } catch {
      return;
    }

    const found = [...(results.pages || []), ...(results.articles || [])].filter((item) => item?.url && item?.title);
    if (!found.length) return;

    const headingId = `LasuraSearchPages-${Math.random().toString(36).slice(2, 8)}`;
    const heading = document.createElement('h2');
    heading.className = 'lasura-search-pages__heading';
    heading.id = headingId;
    heading.textContent = this.dataset.heading || '';

    const list = document.createElement('ul');
    list.className = 'lasura-search-pages__list';
    if (heading.textContent) list.setAttribute('aria-labelledby', headingId);
    found.slice(0, 6).forEach((item) => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'lasura-search-pages__link';
      link.href = item.url;
      link.textContent = item.title;
      li.append(link);
      list.append(li);
    });

    this.replaceChildren(...(heading.textContent ? [heading] : []), list);
    this.hidden = false;
  }
}

if (!customElements.get('lasura-search-pages')) customElements.define('lasura-search-pages', LasuraSearchPages);
